import { ReduxState } from '../types';

export const IDLE = 'IDLE';
export const LOADING = 'LOADING';
export const ERROR = 'ERROR';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const CONFLICT = 'CONFLICT';
export const SUCCESS = 'SUCCESS';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const selectMe = (state: ReduxState) => state.data.me;
export const selectMeBang = (state: ReduxState) => state.data.me!;
export const selectMeStatus = (state: ReduxState) => state.status.me;
export const selectFeatures = /* istanbul ignore next */ (state: ReduxState) =>
  state.data.me!.features;
export const selectEpisodeMetadata = (state: ReduxState) => state.data.episodeMetadata;

export const selectEpisodeId = (state: ReduxState) => {
  return state.data.episodeMetadata!.id;
};

export const selectEpisodeMetadataStatus = (state: ReduxState) => {
  return state.status.episodeMetadata;
};

export const selectEpisodeStartsStreams = (state: ReduxState) => state.data.episodeStartsStreams;

export const selectEpisodeStartsStreamsStatus = (state: ReduxState) => {
  return state.status.episodeStartsStreams;
};

export const selectEpisodePerformance = (state: ReduxState) => state.data.episodePerformance;

export const selectEpisodePerformanceStatus = (state: ReduxState) => {
  return state.status.episodePerformance;
};

export const selectEpisodeV2Enabled = (state: ReduxState) => {
  return !!state.data.episodeV2Enabled;
};

export const selectEpisodeDemographics = (state: ReduxState) => state.data.episodeDemographics;
export const selectEpisodeDemographicsStatus = (state: ReduxState) =>
  state.status.episodeDemographics;
export const selectEpisodeList = (state: ReduxState) => state.data.episodeList;
export const selectEpisodeListStatus = (state: ReduxState) => state.status.episodeList;
export const selectPodcastMetadata = (state: ReduxState) => state.data.podcastMetadata;
export const selectPodcastId = (state: ReduxState) => state.data.podcastMetadata.id;
export const selectPodcastMetadataStatus = (state: ReduxState) => state.status.podcastMetadata;
export const selectPodcastStartsStreams = (state: ReduxState) => state.data.podcastStartsStreams;
export const selectPodcastStartsStreamsStatus = (state: ReduxState) =>
  state.status.podcastStartsStreams;
export const selectPodcastDemographics = (state: ReduxState) => state.data.podcastDemographics;
export const selectPodcastDemographicsStatus = (state: ReduxState) =>
  state.status.podcastDemographics;
export const selectNetworkPodcastList /* istanbul ignore next */ = (state: ReduxState) =>
  state.data.networkPodcastList;
export const selectNetworkPodcastListStatus /* istanbul ignore next */ = (state: ReduxState) =>
  state.status.networkPodcastList;
export const selectNetworkMetadata = (state: ReduxState) => state.data.networkMetadata;
export const selectNetworkMetadataStatus = (state: ReduxState) => state.status.networkMetadata;
export const selectEpisodeListeners = (state: ReduxState) => state.data.episodeListeners;

export const selectEpisodeListenersStatus = (state: ReduxState) => {
  return state.status.episodeListeners;
};

export const selectDateRange = (state: ReduxState) => {
  return state.data.dateRange;
};

export const selectDatesAvailable = (state: ReduxState) => {
  return state.data.me!.dataRange;
};

export const selectLastUpdatedDate = (state: ReduxState) => state.data.me!.dataRange.until;

export const selectNetworkListStatus = (state: ReduxState) => {
  return state.status.networkList;
};

export const selectNetworkList = (state: ReduxState) => state.data.networkList;
export const selectNetworkTopPodcasts = (state: ReduxState) => state.data.networkTopPodcasts;
export const selectNetworkTopPodcastsStatus = (state: ReduxState) =>
  state.status.networkTopPodcasts;
export const selectNetworkTopEpisodes = (state: ReduxState) => state.data.networkTopEpisodes;
export const selectNetworkTopEpisodesStatus = (state: ReduxState) =>
  state.status.networkTopEpisodes;
export const selectNetworkStartsStreams = (state: ReduxState) => state.data.networkStartsStreams;
export const selectNetworkStartsStreamsStatus = (state: ReduxState) =>
  state.status.networkStartsStreams;
export const selectNetworkDemographics = (state: ReduxState) => state.data.networkDemographics;
export const selectNetworkDemographicsStatus = (state: ReduxState) =>
  state.status.networkDemographics;
export const selectNetworkListeners = (state: ReduxState) => state.data.networkListeners;
export const selectNetworkListenersStatus = (state: ReduxState) => state.status.networkListeners;
export const selectNetworkFollowers = (state: ReduxState) => state.data.networkFollowers;

export const selectNetworkFollowersStatus = (state: ReduxState) => {
  return state.status.networkFollowers;
};

export const selectPodcastListeners = (state: ReduxState) => state.data.podcastListeners;
export const selectPodcastListenersStatus = (state: ReduxState) => state.status.podcastListeners;
export const selectPodcastFollowers = (state: ReduxState) => state.data.podcastFollowers;
export const selectPodcastFollowersStatus = (state: ReduxState) => state.status.podcastFollowers;
export const selectFeed = /* istanbul ignore next */ (state: ReduxState) => state.data.rssFeed;
export const selectFeedValidationStatus = (state: ReduxState) => state.status.rssFeed;

export const selectNetworkSearchResults = /* istanbul ignore next */ (state: ReduxState) => {
  return state.data.networkSearchResults;
};

export const selectNetworkSearchStatus = (state: ReduxState) => {
  return state.status.networkSearchResults;
};

export const selectFeedSubmissionStatus = (state: ReduxState) => state.status.submitFeed;
export const selectSubmittedFeed = /* istanbul ignore next */ (state: ReduxState) =>
  state.data.submitFeed;
export const selectCategoriesStatus = (state: ReduxState) => state.status.categories;

export const selectCountriesStatus = (state: ReduxState) => {
  return state.status.countries;
};

export const selectLanguagesStatus = (state: ReduxState) => {
  return state.status.languages;
};

export const selectCategories = /* istanbul ignore next */ (state: ReduxState) =>
  state.data.categories;
export const selectCountries = /* istanbul ignore next */ (state: ReduxState) =>
  state.data.countries;
export const selectLanguages = /* istanbul ignore next */ (state: ReduxState) =>
  state.data.languages;
export const selectUserShows = (state: ReduxState) => state.data.meShows;
export const selectUserShowsStatus = (state: ReduxState) => state.status.meShows;

export const selectCategoriesState = (state: ReduxState) => {
  return state.data.categoriesState;
};

export const selectCountriesState = (state: ReduxState) => state.data.countriesState;
export const selectLanguagesState = (state: ReduxState) => state.data.languagesState;
export const selectCurrentNetworkId = (state: ReduxState) => state.data.currentNetworkId;
export const selectPendingPodcastsStatus = (state: ReduxState) => state.status.pendingPodcasts;
export const selectPendingPodcasts = /* istanbul ignore next */ (state: ReduxState) =>
  state.data.pendingPodcasts;
export const selectAggregators = (state: ReduxState) => state.data.aggregators;
export const selectAggregatorsStatus = (state: ReduxState) => state.status.aggregators;
export const selectAggregatorsState = (state: ReduxState) => state.data.aggregatorsState;
export const selectMetadataErrors = (state: ReduxState) => state.data.metadataError;
export const selectSendVerificationEmailStatus = (state: ReduxState) =>
  state.status.sendVerificationEmail;

export const selectCheckVerificationCodeStatus = (state: ReduxState) => {
  return state.status.checkVerificationCode;
};

export const selectCheckVerificationCode = /* istanbul ignore next */ (state: ReduxState) =>
  state.data.checkVerificationCode;
